import { render, staticRenderFns } from "./ModalListaPeriodo.vue?vue&type=template&id=cd85ab08"
import script from "./ModalListaPeriodo.vue?vue&type=script&lang=js"
export * from "./ModalListaPeriodo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports